<!--
  CheckoutForm Error Codes: {
    1010: No payment options available
  }
-->

<template>
  <div>
    <pickup-details-card />

    <hr class="paymentDividor">

    <personal-details-card />

    <optin-rewards />

    <hr class="paymentDividor">

    <payment-card ref="paymentCard" />
  </div>
</template>

<script>
import PickupDetailsCard from '@/components/Checkout/PickupDetailsCard'
import PersonalDetailsCard from '@/components/Checkout/PersonalDetailsCard'
import OptinRewards from '@/components/Checkout/OptinRewards'
import PaymentCard from '@/components/Checkout/PaymentCard'

export default {
  components: {
    PickupDetailsCard,
    PersonalDetailsCard,
    OptinRewards,
    PaymentCard
  },

  methods: {
    selectApplePay() {
      this.$refs.paymentCard.selectApplePay()
    }
  }
}
</script>

<style>
  .checkout-form {
    padding: 0px 20px 20px;
    width: 100%;
  }

  .paymentDividor {
    width: 110%;
    position: relative;
    left: -5%;
    margin: 10px auto 20px;

    border-top: 1px solid var(----card-border-color);
  }

  /* Commenting this change based on the ticket DEV-4573 */
  /* .v-list {
    background: transparent !important;
  } */

  .place-order {
    padding: 0px 20px 20px 20px;
  }

  .v-list.checkout-form>div:hover {
    background-color: var(--hover-colour);
  }

  .v-list__tile.v-list__tile--link.theme--light:hover {
    background: none !important;
    background-color: none !important;
  }
  .v-btn.v-btn--outline {
    border-color: silver !important
  }
</style>
<style scoped>

</style>
